import { createAction, props } from '@ngrx/store';

import { PublicProfile } from '@offconon/core-api';

import { UserEntity } from './user.models';

export const initUser = createAction('[User Page] Init');

export const loadUserSuccess = createAction(
  '[User/API] Load User Success',
  props<{ user: UserEntity[] }>(),
);

export const loadUserFailure = createAction(
  '[User/API] Load User Failure',
  props<{ error: any }>(),
);

export const fetchUserList = createAction(
  '[User/API] Fetch User List',
  props<{
    page?: number;
    pageSize?: number;
    searchJson?: {
      id?: number;
      including_ids?: any;
      excluding_ids?: any;
      username?: string;
    };
  }>(),
);
export const onSuccessfullyFetchedUserList = createAction(
  '[User/API] Set User List',
  props<{ userList: PublicProfile[] }>(),
);

export const fetchUserById = createAction('[User/API] Fetch User By Id', props<{ id: number }>());
